<template>
    <div class="phone-card-component">
        <div class="phone-card-component__header">
            <div>
                <span class="phone-card-component__eyebrow">Contatos</span>
                <h6 :class="required ? 'required': ''">
                    <i class="icon-phone"></i> {{ t('GENERAL.PHONE') }}
                </h6>
                <small>{{ phones?.length ? 'Telefones cadastrados para contato.' : t('GENERAL.MSG.NONE_PHONE_REGISTER') }}</small>
            </div>
            <button
                    data-cy="user_index_add_phone"
                    class="btn btn-primary phone-card-component__add"
                    type="button"
                    data-target="#addNew"
                    data-toggle="modal"
                    @click="startAdd()"
                    v-if="!isView">
                <i class="icon-plus"></i> {{ t('ACTIONS.NEW') }}
            </button>
        </div>

        <div class="phone-card-component__list" v-if="phones && phones[0]">
            <div class="phone-card-component__item" v-for="(phone, key) in phones" :key="phone.id || key">
                <div class="phone-card-component__avatar">
                    <i class="icon-phone"></i>
                </div>
                <div class="phone-card-component__content">
                    <div class="phone-card-component__meta">
                        <span class="phone-card-component__type" v-if="types">
                            {{ types.find(t => t.id == phone.type).text }}
                        </span>
                        <span class="phone-card-component__number">
                            <vue-tel-input
                                    mode="national"
                                    class="w-100 phone-card-component__tel"
                                    v-model="phone.number"
                                    disabled
                                    :autoFormat="true"
                                    :preferredCountries="['US', 'DE', 'FR', 'CN']"
                                    :defaultCountry="phone?.code_country ? parseInt(phone.code_country) : 55"
                                    :dropdownOptions="dropdownOptions"
                                    :inputOptions="inputOptions"
                            ></vue-tel-input>
                        </span>
                    </div>
                    <small class="phone-card-component__description">
                        {{ phone.description || t('GENERAL.COMMENT') }}
                    </small>
                </div>
                <div class="phone-card-component__actions align-self-center" v-if="!isView">
                    <button
                            data-cy="user_index_phone_update"
                            class="btn btn-outline-primary btn-sm" type="button"
                            @click="edit(phone, key)">
                        <i class="icon-edit"></i>
                    </button>
                    <button
                            data-cy="user_index_phone_delete"
                            class="btn btn-outline-danger btn-sm" type="button"
                            @click="deletePhone(key)">
                        <i class="icon-delete"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="phone-card-component__empty" v-else>
            {{ t('GENERAL.MSG.NONE_PHONE_REGISTER') }}
        </div>

        <div v-if="firstModal == 'true'" class="validation text-left mt-2">
            {{ t('GENERAL.MSG.PLEASE_ADD_A_PHONE_TO_GO_AFTER') }}
        </div>

        <transition name="fade">
            <div class="modal-mask" v-if="add">
                <div class="modal-wrapper" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog phone-card-modal" role="document">
                        <div class="modal-content">
                            <div class="modal-header modal-header-color phone-card-modal__header">
                                <div>
                                    <span class="phone-card-component__eyebrow">{{ isEdit ? t('ACTIONS.UPDATE') : t('ACTIONS.NEW') }}</span>
                                    <h4 class="modal-title">{{ t('GENERAL.PHONE') }}</h4>
                                </div>
                                <button type="button" class="closeX" id="closeX" @click="cancel()">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-open">
                                <div class="modal-body modal-row2 phone-card-modal__body">
                                    <div class="row gutters">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                            <div data-cy="user_index_add_type_phone" class="form-group" id="block_type_phone">
                                                <label class="required">{{ t('GENERAL.PHONE_TYPE') }}: </label>
                                                <Select2
                                                        :settings="{
                                                            width: '100%',
                                                            placeholder: 'Selecione',
                                                            dropdownParent: '#block_type_phone',
                                                        }"
                                                        :options="types"
                                                        v-model="type"
                                                />
                                                <div class="validation" id="invalidType" style="display: none">
                                                    {{ t('GENERAL.MSG.REQUIRED_FIELD') }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                            <div class="form-group">
                                                <label for="phone" class="required">{{ t('COMPANIES.NUMBER') }}: </label>
                                                <vue-tel-input
                                                        mode="national"
                                                        v-model="number"
                                                        :autoFormat="true"
                                                        :preferredCountries="['US', 'DE', 'FR', 'CN']"
                                                        :defaultCountry="codeCountry"
                                                        @country-changed="changeCountry"
                                                        :dropdownOptions="dropdownOptions"
                                                        :inputOptions="inputOptions"
                                                ></vue-tel-input>
                                                <div class="validation" id="invalidphone" style="display: none">
                                                    {{ t(msgPhone) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row gutters">
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label>{{ t("GENERAL.COMMENT") }}: </label>
                                                <textarea
                                                        class="form-control"
                                                        v-model="description"
                                                        maxlength="60"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer justify-content-end phone-card-modal__footer">
                                <button class="btn btn-secondary mr-2" type="button" @click="cancel()">
                                    {{ t("ACTIONS.CLOSE") }}
                                </button>
                                <button data-cy="user_index_add_phone_save" class="btn btn-primary" type="button" @click="createPhone()">
                                    {{ t("ACTIONS.SAVE") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {useI18n} from "vue-i18n";
import {useToast} from "vue-toastification";
import Select2 from 'vue3-select2-component';
import Validate from '@/components/validate.vue';
import {VueTelInput} from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
export default {
    name: 'phoneComponent',
    mixins: [Validate],
    props: {
        phonesIndex: {
            type: Array,
        },
        isView: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        isPublic: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        Select2,
        VueTelInput,
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data() {
        return {
            dropdownOptions: {
                showDialCodeInList: true,
                showDialCodeInSelection: true,
                showFlags: true,
                showSearchBox: true,
            },
            inputOptions: {
                'aria-describedby': 'des',
                showDialCode: false,
                placeholder: '',
                tabindex: 1050,
                maxlength: 29,
            },
            add: false,
            type: null,
            phones: [],
            types: [
                {id: 0, text: 'Whatsapp'},
                {id: 1, text: 'Ligação'},
                {id: 2, text: 'Ligação e Whatsapp'}
            ],
            number: null,
            codeCountry: 55,
            country_acronym: 'BR',
            isEdit: false,
            position: null,
            firstPhone: null,
            description: null,
            firstModal: localStorage.getItem('firstProfileClosed'),
        }
    },

    watch: {
        phonesIndex: function () {
            this.add = false;
            this.type = null;
            this.number = null;
            this.codeCountry = 55;
            this.country_acronym = 'BR';
            this.position = null;
            this.description = null;
            this.phones = this.phonesIndex ? this.phonesIndex : [];
            this.firstPhone = localStorage.getItem('firstProfileClosed');
        },
    },
    created() {
        this.phones = this.phonesIndex ? this.phonesIndex : [];
    },
    emits:['update'],
mounted() {
      console.log(this.isView, 'isView')
},
    methods: {
        changeCountry(val) {
            this.codeCountry = val.dialCode;
            this.country_acronym = val.iso2;
        },
        startAdd() {
            this.add = true;
            this.type = null;
            this.number = null;
            this.codeCountry = 55;
            this.country_acronym = 'BR';
            this.isEdit = false;
            this.position = null;
            this.description = null;
        },

        edit(phone, key) {
            this.add = true;
            this.isEdit = true;
            this.position = key;
            this.type = phone.type;
            this.number = phone.number;
            this.codeCountry = phone.code_country ? parseInt(phone.code_country) : 55;
            this.country_acronym = phone.country_acronym ? phone.country_acronym : 'BR';
            this.description = phone.description;
        },

        createPhone() {
            this.invalid = [];
            //  this.validatePhone(this.number, 'phone');

            if (this.type == null) {
                this.invalid.push(true);
                document.getElementById("invalidType").style.display = "block";
            } else {
                document.getElementById("invalidType").style.display = "none";
            }

            if (this.invalid.length == 0) {
                if (this.isEdit) {
                    this.phones.splice(this.position, 1);
                }

                this.add = false;

                this.phones.push(
                        {
                            type: this.type,
                            number: this.number,
                            description: this.description,
                            code_country: this.codeCountry,
                            country_acronym: this.country_acronym,
                        }
                );
                this.$emit('update', this.phones);
            }
        },

        deletePhone(key) {
            this.phones.splice(key, 1);
            this.$emit('update', this.phones);
        },

        inputValid(input, id) {
            document.getElementById(id).classList.remove("is-valid");
            document.getElementById(id).classList.remove("is-invalid");
            this.validate(input, id);
        },

        validate(input, id) {
            if (input && (input.length == 14 || input.length == 15)) {
                document.getElementById(id).classList.add("is-valid");
                return true;
            } else {
                document.getElementById(id).classList.add("is-invalid");
                return false;
            }
        },

        saveWithEnter(log) {
            if (log.key == 'Enter') {
                this.createPhone();
            }
        },

        customClass(value, key, isThead = false) {
            let col = '';
            let color = '';

            if (isThead) {
                color = '';
            } else
                color = key % 2 != 0 ? 'contact-table-row-alt' : 'table-grey';

            switch (value) {
                case 0:
                    col = !this.isView ? ' col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6' : ' col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6';
                    return color + col;
                case 1:
                    col = !this.isView ? ' col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6' : ' col-xl-4 col-lg-2 col-md-2 col-sm-6 col-6';
                    return color + col;
                case 2:
                    col = !this.isView ? ' col-xl-5 col-lg-5 col-md-5 col-sm-6 col-6' : ' col-xl-5 col-lg-7 col-md-7 col-sm-12 col-12';
                    return color + col;
                case 3:
                    col = ' col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6';
                    return color + col;
            }
        },

        cancel() {
            this.add = false;
        }
    }
}
</script>

<style scoped>
.phone-card-component {
    background:
        radial-gradient(ellipse at 0% 0%, rgba(14, 94, 78, 0.08), rgba(14, 94, 78, 0.035) 24%, transparent 58%),
        linear-gradient(135deg, #ffffff 0%, #fbfcfd 58%, #f7f9fb 100%);
    border: 1px solid #dce3ea;
    border-radius: 14px;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.88),
        0 12px 28px rgba(15, 23, 42, 0.06);
    padding: 18px;
}

.phone-card-component__header {
    align-items: center;
    display: flex;
    gap: 14px;
    justify-content: space-between;
    margin-bottom: 14px;
}

.phone-card-component__eyebrow {
    color: #0e5e4e;
    display: block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .08em;
    text-transform: uppercase;
}

.phone-card-component h6 {
    color: #173b34;
    font-weight: 700;
    margin: 2px 0;
}

.phone-card-component small {
    color: #6b7c78;
}

.phone-card-component__add {
    border-radius: 10px;
    white-space: nowrap;
}

.phone-card-component__list {
    display: grid;
    gap: 10px;
}

.phone-card-component__item {
    align-items: center;
    background: #ffffff;
    border: 1px solid #e3eeeb;
    border-radius: 12px;
    display: flex;
    gap: 12px;
    padding: 12px;
}

.phone-card-component__avatar {
    align-items: center;
    background: #0e5e4e;
    border-radius: 12px;
    color: #ffffff;
    display: flex;
    flex: 0 0 42px;
    height: 42px;
    justify-content: center;
}

.phone-card-component__content {
    align-items: center;
    display: flex;
    flex: 1;
    gap: 12px;
    min-width: 0;
}

.phone-card-component__meta {
    align-items: center;
    display: grid;
    flex: 1;
    gap: 10px;
    grid-template-columns: minmax(130px, 180px) minmax(180px, 1fr);
    min-width: 0;
}

.phone-card-component__type {
    color: #173b34;
    font-weight: 700;
}

.phone-card-component__number {
    min-width: 0;
}

.phone-card-component__description {
    display: block;
    flex: 0 0 260px;
    margin-top: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.phone-card-component__actions {
    align-items: center;
    display: flex;
    gap: 8px;
}

.phone-card-component__actions .btn {
    align-items: center;
    display: inline-flex;
    height: 34px;
    justify-content: center;
    min-width: 34px;
}

.phone-card-component__empty {
    background: rgba(14, 94, 78, 0.06);
    border: 1px dashed #b9d8d0;
    border-radius: 12px;
    color: #52716a;
    font-size: 13px;
    padding: 12px;
    text-align: center;
}

.phone-card-component__tel :deep(.vue-tel-input),
.phone-card-component__tel.vue-tel-input {
    opacity: 1;
}

.phone-card-modal {
    margin-top: 0;
}

.phone-card-modal .modal-content {
    border: 0;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 24px 70px rgba(15, 23, 42, .24);
}

.phone-card-modal__header {
    align-items: center;
    display: flex;
    justify-content: space-between;
}

.phone-card-modal__body {
    max-height: calc(100vh - 200px);
    padding: 20px;
}

.phone-card-modal__body textarea.form-control {
    min-height: 130px;
}

.phone-card-modal__footer {
    border-top: 1px solid #e3eeeb;
    padding: 14px 20px;
}

:global(html.dark-theme .phone-card-component),
:global(html.dark-theme .phone-card-modal .modal-content ){
    background:
        radial-gradient(ellipse at 0% 0%, rgba(20, 184, 166, 0.20), rgba(20, 184, 166, 0.10) 24%, transparent 58%),
        linear-gradient(135deg, rgba(17, 24, 39, 0.98) 0%, rgba(23, 32, 51, 0.96) 100%) !important;
    border-color: rgba(94, 234, 212, 0.18) !important;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.04),
        inset 0 0 0 1px rgba(148, 163, 184, 0.08),
        -14px -12px 38px rgba(20, 184, 166, 0.11),
        0 18px 42px rgba(2, 6, 23, 0.36) !important;
    color: var(--dark-text-soft) !important;
}

:global(html.dark-theme .phone-card-component h6),
:global(html.dark-theme .phone-card-component__type),
:global(html.dark-theme .phone-card-modal .modal-title ){
    color: var(--dark-text) !important;
}

:global(html.dark-theme .phone-card-component__eyebrow ){
    color: var(--dark-primary) !important;
}

:global(html.dark-theme .phone-card-component small),
:global(html.dark-theme .phone-card-component__description ){
    color: var(--dark-text-muted) !important;
}

:global(html.dark-theme .phone-card-component__item ){
    background: var(--dark-surface-2) !important;
    border-color: var(--dark-border) !important;
}

:global(html.dark-theme .phone-card-component__empty ){
    background: var(--dark-primary-soft) !important;
    border-color: var(--dark-border-strong) !important;
    color: var(--dark-text-soft) !important;
}

:global(html.dark-theme .phone-card-component__avatar ){
    background: var(--dark-surface-3) !important;
    color: var(--dark-primary) !important;
}

:global(html.dark-theme .phone-card-modal__footer ){
    border-top-color: var(--dark-border) !important;
}

.dropdown-menu2 {
    width: 31% !important;
    left: -11px !important;
    min-width: 31% !important;
}

.item-custom {
    padding-top: 6px;
    background: transparent;
    padding-bottom: 2px;
}

.font-14 {
    font-size: 14px;
}

.red {
    color: red;
}

.btn-dropdown {
    border-radius: 50%;
    padding: 0.2rem 0.5rem;
}

.num-dropdown {
    color: white;
    font-size: 15px;
}

.phone {
    display: flex;
    padding-top: 1%;
    padding-bottom: 3%;
    align-items: center;
    justify-content: space-between;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 1.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */
{
    opacity: 0;
}

.hide-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.table-white,
.contact-table-row-alt {
    background-color: transparent !important;
}

.bb {
    border-bottom: 2px solid #d9dee4 !important;
}

.contact-table-header {
    background-color: transparent !important;
    border-bottom: 2px solid #d9dee4;
}

.td-phone {
    padding-top: 1rem;
}

.pd-1 {
    padding: 1rem;
}

@media screen and (min-width: 771px) {
    .max-width-type {
        max-width: 21.6%;
    }

    .min-width-number {
        min-width: 20%;
    }
}

@media (min-width: 576px) {
    ::v-deep .vti__dropdown-list {
        max-width: 240px;
    }
}

@media (max-width: 767px) {
    .phone-card-component {
        padding: 16px;
    }

    .phone-card-component__header,
    .phone-card-component__item {
        align-items: flex-start;
        flex-direction: column;
    }

    .phone-card-component__add,
    .phone-card-component__actions,
    .phone-card-component__actions .btn {
        width: 100%;
    }

    .phone-card-component__avatar {
        display: none;
    }

    .phone-card-component__content {
        align-items: flex-start;
        flex-direction: column;
        width: 100%;
    }

    .phone-card-component__meta {
        grid-template-columns: 1fr;
    }

    .phone-card-component__description {
        flex: initial;
        white-space: normal;
    }

    .phone-card-modal {
        margin: 0.5rem;
    }
}
</style>
